module.exports = __webpack_public_path__ + "static/media/frames-12.14bc051e.jpg";